export function playVideo() {
  const video = document.querySelector(".article__video");
  const playButton = document.querySelector(".article__pic-box");
  const icon = document.querySelector(".article__icon");
  const playIcon =
    "/wp-content/themes/ems/project/src/assets/icons/play-article.svg";
  const pauseIcon =
    "/wp-content/themes/ems/project/src/assets/icons/pause-article.svg";

  if (!(video && playButton && icon)) return;

  playButton.addEventListener("click", function () {
    console.log("клик");

    if (video.paused) {
      video.play();
      icon.src = pauseIcon;
    } else {
      video.pause();
      icon.src = playIcon;
    }
  });
}
